import "Data/ServerSource";

/** @namespace Accounting.Data */
NS("Accounting.Data");

/**
 * Accounting.Data.Objects source
 * @class
 * @extends Data.ServerSource
 */
Accounting.Data.Objects = Class(Data.ServerSource, /** @lends Accounting.Data.Objects.prototype */ {
    url: "Accounting/Web/Objects/",
    fields: [
        { name: "id", title: "id" }, // int
        { name: "kindid", title: "kindid" }, // int
        { name: "description", title: "description" }, // string
        { name: "attributes", title: "attributes" }, // json

        { name: "createddatetime", title: "createddatetime" }, // string
        { name: "modifieddatetime", title: "modifieddatetime" }, // string
        { name: "creator", title: "creator" }, // json
        { name: "modifier", title: "modifier" }, // json
    ]
});
